/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives" DataTable endpoint.
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "./constants";
import type {
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreatives = reactQueryTableFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
  (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      limit = 20,
      start = 0,
      query,
      sortby,
      sortdir,
    }: GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesParams
  ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult> =>
    fetch<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult>(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/base_creatives`,
      "GET",
      {
        limit,
        start,
        sortby,
        sortdir,
        query: serializeQueryObjects((query ?? {}) as Queries),
      },
      { signal }
    ),
  isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesResult
);
